module.exports = __webpack_public_path__ + "img/person.b31adbf6.png";